import type {
  FmMapLayerDescriptor,
  FmMapLayerId,
} from './FmMapWorkspaceRoot.types';

export type FmMapLayerControlKind =
  | 'visibility'
  | 'risk-access'
  | 'radar-playback';

export interface FmMapLayerCapability {
  id: FmMapLayerId;
  kind: FmMapLayerDescriptor['kind'];
  control: FmMapLayerControlKind;
}

export const FM_MAP_LAYER_CAPABILITIES: Readonly<
  Record<FmMapLayerId, FmMapLayerCapability>
> = Object.freeze({
  'property-boundary': {
    id: 'property-boundary',
    kind: 'boundary',
    control: 'visibility',
  },
  'forest-stands': {
    id: 'forest-stands',
    kind: 'stands',
    control: 'visibility',
  },
  'measurement-plots': {
    id: 'measurement-plots',
    kind: 'measurement-plots',
    control: 'visibility',
  },
  'sentry-risks': {
    id: 'sentry-risks',
    kind: 'risk',
    control: 'risk-access',
  },
  'rain-radar': {
    id: 'rain-radar',
    kind: 'radar',
    control: 'radar-playback',
  },
});

export function mapLayerCapability(
  layer: FmMapLayerDescriptor,
): FmMapLayerCapability {
  return FM_MAP_LAYER_CAPABILITIES[layer.id];
}

export function isFmMapLayerId(value: string): value is FmMapLayerId {
  return value in FM_MAP_LAYER_CAPABILITIES;
}
